<template>
    <div class="search">
        <p class="search__title">Orders</p>
        <div class="search__input-wrapper">
            <v-autocomplete
                v-model="order"
                :items="orders"
                dense
                outlined
                label="Orders"
                :error-messages="errorMessages"
                item-color="#967adc"
                hide-no-data
                :loading="ordersIsFetching"
                :hide-details="hideDetails"
                @change="selectHandle"
                @update:search-input="handleInput"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { find } from 'lodash'
import { actionTypes, getterTypes } from '@/store/modules/orders'

export default {
    name: 'OrderFormSelect',
    props: {
        // eslint-disable-next-line vue/require-default-prop
        selectedId: null,
        errorMessages: {
            type: [String, Array],
            default: () => '',
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
    },
    emits: ['select-handle'],
    data() {
        return {
            order: {},
            value: {},
            search: '',
            searchQueryTimeout: null,
        }
    },
    computed: {
        ...mapGetters('orders', {
            getSearchResults: getterTypes.getSearchResults,
            getSearchPagination: getterTypes.getSearchPagination,
            ordersIsFetching: getterTypes.isLoading,
        }),
        orders: function () {
            return this.getSearchResults.map((order) => ({
                text: order.title,
                value: {
                    id: order.id,
                    client: order.title,
                },
            }))
        },
    },
    watch: {
        selectedId: function (id) {
            this.selectOrder(id)
        },
        search: function (val) {
            const hasActiveTimeout = !!this.searchQueryTimeout
            const isSameAsCurrent = val === this.order?.client
            const isEmpty = val === ''

            if (val && !isSameAsCurrent) {
                clearTimeout(this.searchQueryTimeout)

                this.searchQueryTimeout = setTimeout(() => {
                    this.searchOrders(val)
                    this.searchQueryTimeout = null
                }, 500)

                return
            }

            if (isEmpty && hasActiveTimeout) {
                const interval = setInterval(() => {
                    if (this.searchQueryTimeout) return
                    clearInterval(interval)
                    this.loadOrders()
                }, 100)
                return
            }

            if (isEmpty && !hasActiveTimeout) {
                this.loadOrders()
            }
        },
    },
    mounted: function () {
        if (this.getSearchResults.length === 0) {
            this.loadOrders()
        }

        this.selectOrder(this.selectedId)
    },
    methods: {
        ...mapActions('orders', {
            loadOrders: actionTypes.loadAllWithSearch,
        }),
        handleInput: function (value) {
            this.search = value
        },
        searchOrders: async function (query) {
            try {
                await this.loadOrders({ search: query, per_page: 20, page: 1 })
            } catch (e) {
                console.error('Search failed:', e)
            }
        },
        selectOrder: async function (id) {
            if (!id) {
                this.order = { id: '', client: '' }
                return
            }

            if (this.getSearchResults.length === 0) {
                await this.loadOrders({ search: '', per_page: 20, page: 1 })
            }

            let found = find(this.getSearchResults, { id })

            if(!found) {
                try {
                    const { wigs } = await this.loadOrders({ search: '', per_page: 20, page: 1 , id})
                    found = wigs?.find((w) => w.id === id)
                } catch(e) {
                    console.error(e)
                }
            }

            if (!found) return

            this.order = {
                id,
                client: found.title,
            }

            this.selectHandle()
        },
        selectHandle: function () {
            if (!this.order?.id) return

            const foundOrder = find(this.getSearchResults, {
                id: this.order.id,
            })

            if (!foundOrder) return

            const { client_id } = foundOrder

            this.$emit('select-handle', {
                id: this.order.id,
                clientId: client_id,
                client: this.order.title,
            })
        },
    },
}
</script>

<style scoped lang="scss">
.search {
    &__title {
        margin-bottom: 15px;
    }

    &__input-wrapper {
        margin-bottom: 0;
    }
}
</style>
